var Patterns;

(function (Patterns) {
  Patterns["SKIP"] = "\\D";
  Patterns["DIGIT"] = "\\d";
  Patterns["MASK_SKIP"] = "[^a-zA-Z0-9]";
  Patterns["MASK_VARIABLE"] = "[a-zA-Z]";
  Patterns["MASK_CONTROLLED"] = "\\d";
})(Patterns || (Patterns = {}));

function testPatternOn(str, pattern) {
  return new RegExp(pattern).test(str);
}

function buildInspector(pattern, lastIndex) {
  var inspector = new RegExp(pattern, 'g');
  lastIndex && (inspector.lastIndex = lastIndex);
  return inspector;
}

function buildInputStateWithCursor(value, cursor) {
  return {
    value: value,
    selection: {
      start: cursor,
      end: cursor
    }
  };
}

function applyMaskToInput(config, maskInspector, input, inputInspector) {
  var _a, _b;

  var mask = config.mask,
      formatChars = config.formatChars;
  var substitutuon = '';
  var isStopped = false;

  while (!isStopped) {
    var maskPrevLastIndex = maskInspector.lastIndex;
    var inputDigit = (_a = inputInspector.exec(input)) === null || _a === void 0 ? void 0 : _a[0];
    var maskMatch = (_b = maskInspector.exec(mask)) === null || _b === void 0 ? void 0 : _b[0];
    maskMatch && inputDigit && testPatternOn(inputDigit, formatChars[maskMatch[0]]) ? substitutuon += "".concat(inputDigit).concat(maskMatch.slice(1)) : maskInspector.lastIndex = maskPrevLastIndex;
    isStopped = maskMatch === undefined || inputDigit === undefined;
  }

  return substitutuon;
}
/* Works only for country codes with single digit */


function applyCountryCodeAutocomplete(config, input, inputInspector) {
  var _a, _b, _c;

  var mask = config.mask,
      indexOfAreaCode = config.indexOfAreaCode,
      countryCodePattern = config.countryCodePattern;
  var indexAfterPlus = (_b = (_a = input.match(new RegExp("^".concat(Patterns.SKIP, "*[+]")))) === null || _a === void 0 ? void 0 : _a[0].length) !== null && _b !== void 0 ? _b : 0;
  inputInspector.lastIndex = indexAfterPlus;
  var newValue = indexAfterPlus ? '+' : '';
  var firstDigit = (_c = inputInspector.exec(input)) === null || _c === void 0 ? void 0 : _c[0];
  var hasCountryCode = firstDigit && testPatternOn(firstDigit, countryCodePattern);
  firstDigit ? inputInspector.lastIndex -= Number(!hasCountryCode) : inputInspector.lastIndex = input.length;
  return hasCountryCode || firstDigit ? mask.slice(0, indexOfAreaCode) : newValue;
}

function onInsertionOfCountryCode(config, userInput, oldValue, selectionEnd) {
  var mask = config.mask,
      indexOfAreaCode = config.indexOfAreaCode;
  var inputInspector = buildInspector(Patterns.DIGIT);
  var newValue = applyCountryCodeAutocomplete(config, userInput, inputInspector);

  if (newValue === '') {
    return buildInputStateWithCursor(oldValue, indexOfAreaCode);
  }

  var cursor = newValue.length;
  var maskInspector = buildInspector("".concat(Patterns.MASK_VARIABLE).concat(Patterns.MASK_SKIP, "*"), newValue.length);

  if (inputInspector.lastIndex < userInput.length) {
    newValue += applyMaskToInput(config, maskInspector, userInput, inputInspector);
  }

  cursor = newValue.length;

  if (newValue.length < mask.length) {
    inputInspector.lastIndex = selectionEnd !== null && selectionEnd !== void 0 ? selectionEnd : cursor;
    newValue += applyMaskToInput(config, maskInspector, oldValue, inputInspector);
  }

  return buildInputStateWithCursor(newValue, cursor);
}

function onPartialRemovalOfCountryCode(config, oldValue, selectionEnd) {
  var indexOfAreaCode = config.indexOfAreaCode;

  if (oldValue.length <= indexOfAreaCode) {
    return buildInputStateWithCursor('', 0);
  }

  var newValue = oldValue.slice(0, indexOfAreaCode);

  if (indexOfAreaCode < selectionEnd) {
    var maskInspector = buildInspector("".concat(Patterns.MASK_VARIABLE).concat(Patterns.MASK_SKIP, "*"), newValue.length);
    var inputInspector = buildInspector(Patterns.DIGIT);
    var remainder = oldValue.slice(selectionEnd);
    newValue += applyMaskToInput(config, maskInspector, remainder, inputInspector);
    return buildInputStateWithCursor(newValue, indexOfAreaCode);
  }

  return buildInputStateWithCursor(oldValue, indexOfAreaCode);
}

export default function getCountryCodeAutocompleter(maskConfig, countryCodePattern) {
  var indexAfterCountryCode = maskConfig.mask.search(/[^+\d]/);
  var indexOfAreaCode = maskConfig.mask.search(/[a-z]/i);
  var phoneConfig = Object.assign(Object.assign({}, maskConfig), {
    indexOfAreaCode: indexOfAreaCode,
    countryCodePattern: countryCodePattern
  });
  return function (newState, oldState, userInput) {
    var oldSelection = oldState.selection;
    var newSelection = newState.selection;

    if (oldSelection && newSelection && oldSelection.start <= indexOfAreaCode) {
      if (userInput && oldSelection.start < indexAfterCountryCode) {
        return onInsertionOfCountryCode(phoneConfig, userInput, oldState.value, oldSelection.end);
      }

      if (userInput === null && newState.value.length < oldState.value.length && !(oldSelection.start === 0 && oldSelection.end === oldState.value.length && oldState.value.length) && !(oldSelection.start === oldSelection.end && oldSelection.start <= newSelection.start && (oldSelection.start === 0 || oldSelection.start === indexOfAreaCode))) {
        return onPartialRemovalOfCountryCode(phoneConfig, oldState.value, oldSelection.end);
      }
    }

    return newState;
  };
}